// extracted by mini-css-extract-plugin
module.exports = {"UserList":"user-list_UserList__3jMQI","fade-in":"user-list_fade-in__2LlCi"};